import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { BehaviorSubject, debounceTime, Observable, of, Subject } from 'rxjs';
import { getRandomId } from '../../../utils/get-random-id';
import { BoschUiOptionBarType } from '../bosch-ui-option-bar.model';

@Component({
  selector: 'bosch-ui-option-bar-item',
  templateUrl: './bosch-ui-option-bar-item.component.html',
  styleUrls: ['./bosch-ui-option-bar-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BoschUiOptionBarItemComponent<ValueType> {
  @Input() value: ValueType | null = null;
  @ViewChild('template') public template!: TemplateRef<ValueType>;

  id$: Observable<string> = of(getRandomId('option-bar-item'));
  name$: Observable<string | null>;
  value$: Observable<ValueType>;
  checked$: Observable<boolean>;
  disabled$: Observable<boolean>;
  type$: Observable<BoschUiOptionBarType | null>;

  private _name$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  private _value$: Subject<ValueType> = new Subject<ValueType>();
  private _checked$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _disabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _type$: BehaviorSubject<BoschUiOptionBarType | null> = new BehaviorSubject<BoschUiOptionBarType | null>(null);

  constructor() {
    this.name$ = this._name$.asObservable();
    this.value$ = this._value$.asObservable();
    this.checked$ = this._checked$.asObservable();
    this.disabled$ = this._disabled$.asObservable();
    this.type$ = this._type$.pipe(debounceTime(0));
  }

  set name(name: string) {
    this._name$.next(name);
  }

  set checked(checked: boolean) {
    this._checked$.next(checked);
  }

  set disabled(isDisabled: boolean) {
    this._disabled$.next(isDisabled);
  }

  set type(type: BoschUiOptionBarType) {
    this._type$.next(type);
  }

  onClick(): void {
    if (this.value) {
      this._value$.next(this.value);
    }
  }
}
